import { cn } from '../../lib/cn';

interface LoadingSpinnerProps {
  full?: boolean;
  label?: string;
}

export function LoadingSpinner({ full = false, label = 'Loading…' }: LoadingSpinnerProps) {
  return (
    <div
      className={cn(
        'flex items-center justify-center gap-2 text-cdx-fg-muted',
        full && 'min-h-screen',
      )}
      role="status"
      aria-live="polite"
    >
      <span className="inline-block size-4 border-2 border-cdx-border-subtle border-t-cdx-primary rounded-full animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}
